import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { List } from "immutable";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { MenuItem } from "../menu-item.model";

@Component({
  selector: "app-sub-menu",
  templateUrl: "./sub-menu.component.html",
  styleUrls: ["./sub-menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubMenuComponent implements OnChanges {
  @Input() menuItems: MenuItem[] | List<MenuItem> = [];
  @Output() onClick = new EventEmitter<string>(true);
  @Input() currentRoute = "";

  // Cached, rebuilt only when `menuItems` changes. Previously this was a getter that returned a
  // brand-new Immutable List on every change-detection pass (bound in *ngFor), forcing NgForOf to
  // re-diff every tick and feeding the menu-freeze change-detection loop. See menu.component.ts.
  filteredMenuItems: List<MenuItem> = List<MenuItem>([]);

  get hasMenuItmes(): boolean {
    return ArrayHelper.isAvailable(this.menuItems);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.menuItems) {
      const items = this.hasMenuItmes ? (this.menuItems as any).filter(item => item.show) : [];
      this.filteredMenuItems = List(items);
    }
  }

  isFirstItem(index: number): boolean {
    return index < 1;
  }

  trackByFn(index, item) {
    return index;
  }
  onMenuItemClick(path: string) {
    this.onClick.emit(path);
  }
  navigateExternal(path: string): void {
    window.location.href = path;
  }
  getActiveClass(menuItem: any): string {
    let cssClass = "link";
    if (StringHelper.isAvailable(this.currentRoute)) {
      return  cssClass = this.currentRoute.toLowerCase() === menuItem.path.toLowerCase() ? `${cssClass} active` :  `${cssClass}` ;
      }
    return cssClass;
    }
}
